// Copyright (c) 2016 Deere & Company

import * as productActions from '../../actions-list';
import * as userActions from '../../../user/actions-list';
import Facets, {getDefaultState} from '../state/facets';
import {
    sharedToggleDealerAccountFacetItems,
    sharedUpdateDealerAccountFacetInput,
    sharedUpdateDealerAccountFacetItem
} from '../../../shared/reducers/facets';

const actions = {
    ...productActions,
    ...userActions
};

const updateFacetsRegistrationDateRange = (state, action) =>
    Facets.update(state, {
        registrationDateRange: {
            dateRange: {$set: action.dateRange}
        }
    });

const updateFacetsDeliveryDateRange = (state, action) =>
    Facets.update(state, {
        deliveryDateRange: {
            dateRange: {$set: action.dateRange}
        }
    });

const updateDealerAccountFacetInput = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetInput(state.dealerAccountsFacet, action)
        }
    });

const toggleDealerAccountFacetItems = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedToggleDealerAccountFacetItems(state.dealerAccountsFacet, action)
        }
    });

const updateDealerAccountFacetItem = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $set: sharedUpdateDealerAccountFacetItem(state.dealerAccountsFacet, action)
        }
    });

const updateFacetsOnLoad = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            $merge: {
                allowedDealers: action.allowedDealers,
                displayedDealers: action.allowedDealers,
                isInitialLoad: false,
                selectedDealers: action.allowedDealers
            }
        }
    });

const resetRegistrationFacet = (state, action) =>
    Facets.update(state, {
        dealerAccountsFacet: {
            displayedDealers: {
                $set: action.allowedDealers
            },
            searchInput: {
                $set: ''
            },
            selectedDealers: {
                $set: action.allowedDealers
            }
        },
        deliveryDateRange: {
            $set: getDefaultState().deliveryDateRange
        },
        registrationDateRange: {
            $set: getDefaultState().registrationDateRange
        }
    });

const updateDealers = state =>
    Facets.update(state, {
        dealerAccountsFacet: {
            isInitialLoad: {
                $set: true
            }
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_REGISTRATION_FACETS]: resetRegistrationFacet,
        [actions.TOGGLE_DEALER_ACCOUNT_FACET_ITEMS]: toggleDealerAccountFacetItems,
        [actions.UPDATE_DEALER_ACCOUNT_FACET_ITEM]: updateDealerAccountFacetItem,
        [actions.UPDATE_DELIVERY_FACETS_DATE_RANGE]: updateFacetsDeliveryDateRange,
        [actions.UPDATE_REGISTRATION_DEALER_ACCOUNT_FACET_INPUT]: updateDealerAccountFacetInput,
        [actions.UPDATE_REGISTRATION_FACET_ITEMS_ON_LOAD]: updateFacetsOnLoad,
        [actions.UPDATE_REGISTRATION_FACETS_DATE_RANGE]: updateFacetsRegistrationDateRange,
        [actions.UPDATE_USER_PREFERENCES_ALL_DEALER_ACCOUNTS]: updateDealers,
        [actions.UPDATE_USER_PREFERENCES_DEALER_ACCOUNTS]: updateDealers
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/machine-status-update/reducers/facets.js